export default __webpack_public_path__ + "d958b17858cf8e0dfe2a0531061d1b23.png";